/* unplugin-vue-components disabled */import { render } from "./xform.vue?vue&type=template&id=bf51380a"
import script from "./xform.vue?vue&type=script&lang=js"
export * from "./xform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__